var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CieloLayout',[_c('div',{staticClass:"d-flex flex-column flex-fill"},[_c('TitleText',{staticClass:"spacing-b-6",attrs:{"level":"2"}},[_vm._v("\n            "+_vm._s(_vm.$ml.get('titleViewQrCodeCred'))+"\n        ")]),_c('div',{staticClass:"d-flex flex-column flex-fill"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }